import * as React from "react";
import styled from "styled-components";

export const EmptyStateShade = styled.div`
  opacity: 0.3; // TODO: opacity level, dark/light mode
  pointer-events: none;
  user-select: none;
  outline: 0;
`;
EmptyStateShade.displayName = "EmptyStateShade";

export function EmptyState(): JSX.Element {
  return <></>;
}
